import axios from "axios";
import Router from "../router";
import baseURL from "./configUrl";
import { Message } from "element-ui";
// console.log(axios, "axios");

//  让请求在浏览器中允许跨域携带cookie
axios.defaults.withCredentials = true;
// 使用自定义配置新建一个 axios 实例
const http = axios.create({
  // 基础的请求地址
  baseURL: baseURL,
  // 设置超时时间 15s
  timeout: 1000*30,
});

// 添加超时后的处理（axios中需要你根据error信息来进行判断）
// axios().catch((error) => {
//   const { message } = error;
//   if (error.code === "ECONNABORTED" && message.indexOf("timeout") > -1) {
//     // 超时处理，可以直接弹出错误或者重新发起一次请求
//     ElMessage({
//         message: "请求超时！请检查网络问题",
//         type: "error",
//         duration: 2000
//     })
//     //  let newHttp= new Promise(function (resolve){
//     //      resolve()
//     //  })
//     //  newHttp实例执行完成后会再次执行
//     //  返回一个promise实例，同时重新发起请求，config请求配置，包扩请求头和请求参数
//     //  return newHttp.then(function (){
//     //      return  axios.create({baseURL: 'https://some-domain.com/api/',timeout: 5000});
//     //  })
//   }
//   // 若不是超时,则返回未错误信息
//   return Promise.reject(error);
// });
http.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded";

// 请求拦截器，例如请求的时候在头部加上请求的token
http.interceptors.request.use(
  (config) => {
    let token = JSON.parse(sessionStorage.getItem("userInfo")).ssotoken;
    if (token) {
      if (/\?/.test(config.url)) {
        config.url = `${config.url}&ssotoken=${token}`;
      } else {
        config.url = `${config.url}?ssotoken=${token}`;
      }
      config.headers["ssoToken"] = token;
    } else {
      Router.push({ name: "login" });
    }
    return config; //  有且必须有一个config对象被返回
  },
  (error) => {
    //   对请求错误做些什么
    console.log(error);
    return Promise.reject();
  }
);

// 响应拦截器,例如判断服务器返回的状态，400，500啥的，其实超时可以写到这里面来，我分开写了一个比较直观
http.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      return Promise.resolve(response.data);
    } else {
      return Promise.reject(response);
    }
  },
  // 服务器状态码不是200的情况,这些自定义（需要与后台商量返回）
  (error) => {
    if (error.message.indexOf("timeout") > -1) {
      Message({
        message: "请求超时,请检查网络后重试!",
        type: "error",
        duration: 2000,
      });
      return Promise.reject(error);
    }
    if (error.response.status) {
      let message = ''
      switch (error.response.status) {
        case 400:
          message = '请求错误'
          break;
        case 401:
          message = '未授权,请重新登录'
          break;
        case 403:
          message = '拒绝访问'
          break;
        case 404:
          message = '请求错误,未找到资源'
          break;
        case 405:
          message = '请求方法未允许'
          break;
        case 408:
          message = '请求超时'
          break;
        case 500:
          message = '服务器出错'
          break;
        case 502:
          message = '网络错误'
          break;
        case 503:
          message = '服务不可用'
          break;
        case 504:
          message = '网络超时'
          break;
        case 505:
          message = 'http版本不支持该请求'
          break;
      
        default:
          message = `连接错误${error.response.status}`
          break;
      }
      Message({
        message: message,
        type: "error",
        duration: 2000,
      });
      // 清除token
      if (error.response.status == 401) {
        sessionStorage.removeItem("userInfo");
        sessionStorage.removeItem("schoolList");
        sessionStorage.removeItem("cityList");
        // 跳转登录
        setTimeout(() => {
          Router.push({ name: "login" });
        }, 1000);
      }
    } else {
        Message({
          message: "服务器开小差了，请稍后再试！",
          type: "error",
          duration: 2000,
        });
        return Promise.reject(error);
    }
  }
);

export default http;
